<template>
  <div style="padding: 20px 40px; width: 100%;">
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px">
      <div style="margin: 20px;">
        <el-form-item label="姓名" prop="nonull">
          <el-input v-model="ruleForm.lpname" placeholder="请输入您的名字"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="nonull">
          <el-input v-model="ruleForm.lpno" placeholder="请输入您的身份证号"></el-input>
        </el-form-item>
        <el-form-item label="上传身份证(正面)" class="yyzz_upload">
          <BaseUpLoadFile @resetpath="resetpath" @upok="upzm" :ifimg="ifimg" :curfilepath="zmpath" bucketpath="person"></BaseUpLoadFile>
        </el-form-item>
        <el-form-item label="上传身份证(反面)" class="yyzz_upload">
          <BaseUpLoadFile @resetpath="resetpath" @upok="upfm" :ifimg="ifimg" :curfilepath="fmpath" bucketpath="person"></BaseUpLoadFile>
        </el-form-item>
      </div>
      <div class="savebasepanel">
        <el-button type="primary" @click="savecusinfo('ruleForm')">保存信息</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import Utils from '../../util/utils'
  import BaseUpLoadFile from '../upload/BaseUpLoadFile'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'UpPerson',
    components: {BaseUpLoadFile},
    data () {
      var validateNull = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('不允许为空'));
        } else {
          callback();
        }
      }
      return {
        ifimg: true,
        zmpath: '',
        fmpath: '',
        ruleForm: {
          lpname: '',
          lpno: ''
        },
        rules: {
          nonull: [
            { validator: validateNull, trigger: 'blur' }
          ]
        }
      }
    },
    mounted () {
      that = this
      document.title = '个人账号升级'
    },
    methods: {
      savecusinfo (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let addtime = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
            var adata = {
              cusid: parseInt(1),
              usergroupid: parseInt(8),
              name: {String:that.ruleForm.lpname.toString(),Valid:true},
              nickname: {String:that.ruleForm.lpname.toString(),Valid:true},
              imgurl: {String:'',Valid:true},
              post: {String:'管理员',Valid:true},
              phone: {String:'',Valid:true},
              email: {String:'',Valid:true},
              sfzno: {String:that.ruleForm.lpno.toString(),Valid:true},
              sfzzm: {String:that.zmpath,Valid:true},
              sfzfm: {String:that.fmpath,Valid:true},
              accountid: parseInt(localStorage.getItem('accountid')),
              optime: {String:addtime,Valid:true}
            }
            that.$http({
              url: 'https://api.sqnetsoft.cn/customer/addcususer',
              method: 'post',
              data: adata,
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  localStorage.setItem('usergroupid',8)
                  that.$options.methods.upcusstate()
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
      },
      upcusstate () {
        var adata = {
          cusid: parseInt(1),
          accountid: parseInt(localStorage.getItem('accountid')),
          state: {Int64:parseInt(0),Valid:true}
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/addcusstate',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$emit('showsh',0)
              that.$message({
                type: 'success',
                message: '添加成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      resetpath () {
        this.zmpath = ''
        this.fmpath = ''
      },
      upzm (path) {
        this.zmpath = path
      },
      upfm (path) {
        this.fmpath = path
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/regedit/UpPerson.vue